import { render, staticRenderFns } from "./Preventivi.vue?vue&type=template&id=00d3041a&"
import script from "./Preventivi.vue?vue&type=script&lang=js&"
export * from "./Preventivi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports